import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=41a18588&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&id=41a18588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a18588",
  null
  
)

export default component.exports